<template>
  <div>
    <h2 class="text-h6">Send a test email</h2>
    <h3 class="h4 subtitle mb-4 text-muted">
      Enter one or more email addresses, to send a sample update email for this client.
    </h3>

    <c-input
      v-model="testEmailAddress"
      class="input"
      type="email"
      placeholder="test@email1.com,test2@email.com,test@email3.com"
    />
    <c-button color="primary" :disabled="!testEmailAddress" :class="{ 'is-loading': isSending }" @click="testEmail">
      Send
    </c-button>
  </div>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  components: {},

  props: {
    client: Object,
  },

  data() {
    return {
      error: null,
      isSending: false,
      emailSentOk: false,
      testEmailAddress: null,
    };
  },

  methods: {
    showError(error) {
      this.$store.commit('addErrorMessage', {
        header: 'Email send error',
        message: error,
      });
    },
    testEmail() {
      if (!this.testEmailAddress) {
        return;
      }
      const data = {
        id: this.client._id,
        toEmail: this.testEmailAddress,
      };
      this.isSending = true;
      this.$http
        .post(buildEndpoint('clients/email/send-preview'), data)
        .then((response) => {
          this.isSending = false;
          if (response.data.success) {
            this.emailSentOk = true;
            this.$store.commit('addSuccessMessage', {
              header: 'Email sent',
              message:
                'Hey, it looks like the email was sent successfully! Please check the inbox of the test email you sent it to.',
            });
          } else {
            this.showError(`Error sending test email: ${response.data.error}`);
          }
        })
        .catch((error) => {
          this.isSending = false;
          this.showError(`Error sending test email: ${error.message}`);
        });
    },
  },
};
</script>
